<template>
  <Container
    indent="default-but-on-mobile-lg"
    class="flex max-w-container-max flex-col gap-5 lg:flex-row sm:gap-10"
  >
    <div class="w-full shrink-0 lg:ml-auto lg:max-w-96">
      <!-- IMAGE -->
      <div class="w-full max-lg:flex max-lg:items-center max-lg:gap-6">
        <div
          v-animate-zoom-in-out
          class="
            aspect-square w-full max-w-32 overflow-hidden rounded-full
            lg:ml-auto lg:mt-6 lg:w-full lg:max-w-96
            sm:max-w-44
          "
        >
          <BetterPortraitImage
            v-if="teamMember.use_image_from_betterPortrait"
            :email="teamMember.email"
            class="size-full object-cover"
            :alt="teamMember.title"
          />

          <AppImage
            v-else-if="image"
            :src="image"
            :alt="useMapAltText(image)"
            class="size-full object-cover"
            :aspect-ratio="1"
          />
        </div>

        <h3 class="typo-body-xl lg:hidden">
          {{ name }}<span v-if="name && functionName">,</span>
          <br>{{ functionName }}
        </h3>
      </div>
    </div>

    <div class="w-full lg:col-span-2 lg:pl-20">
      <!-- TEXT -->

      <figure v-animate-children-in-from-bottom class="relative max-w-[50rem] lg:pt-[0.75em]">
        <div class="absolute left-0 top-0 shrink-0 grow-0 -translate-x-[120%] items-start">
          <IconQuote class="w-9 lg:w-20 max-lg:-ml-1" />
        </div>

        <!-- QUOTE -->
        <blockquote
          class="typo-body-2xl after:content-none before:content-none lg:typo-body-4xl"
          v-html="data.text"
        />

        <IconQuote class="ml-auto w-9 translate-x-[40%] rotate-180 lg:w-20 max-lg:mt-[-1.75em]" />

        <!-- NAME & FUNCTION  -->
        <figcaption
          v-if="teamMember"
          class="-mt-10 pr-20 typo-body-2xl max-lg:hidden"
        >
          <span>{{ name }}</span>
          <span v-if="name && functionName">,&nbsp;</span>

          <span>{{ functionName }}</span>
        </figcaption>
      </figure>
    </div>
  </container>
</template>

<script lang="ts" setup>
import type { ComponentsMainQuotesFragment } from '#gql'

const props = defineProps<{
  data: NonNullable<ComponentsMainQuotesFragment['quotes']>[number]
}>()

const teamMember = ref<Partial<ComponentsMainQuotesFragment['quotes'][number]['team_member']>>(props.data?.team_member || {})

const image = computed(() => {
  return props.data.is_linking_teammember
    ? teamMember.value?.image
    : props.data.image
})

const name = computed(() => {
  return props.data.is_linking_teammember
    ? teamMember.value?.title
    : props.data.name
})

const functionName = computed(() => {
  return props.data.is_linking_teammember
    ? teamMember.value?.function
    : props.data.function
})
</script>
